import { sendPost } from '@utils/request';

// 加入购物车
export const fetchaddCart = data => {
  const url = '/newCartContract/addCartItem';
  return sendPost({ url, data });
};

export const fetchCartList = data => {
  const url = '/newCartContract/listUserCartItem';
  return sendPost({ url, data });
};

// 购物车选中记忆
export const signCartGoods = data => {
  const url = '/newCartContract/signCartGoods';
  return sendPost({ url, data });
};

// 变更商品规格
export const updateGoodsFlag = data => {
  const url = '/newCartContract/updateGoodsFlag';
  return sendPost({ url, data });
};

// 更新购物车数量
export const updateCartItemNum = data => {
  const url = '/newCartContract/updateCartGoodNum';
  return sendPost({ url, data });
};

// 超级卡限礼包商品
export const buyGoodsInfosCheck = data => {
  const url = '/newCartContract/buyGoodsInfosCheck';
  return sendPost({ url, data });
};


// 删除购物车
export const deleteCartGoods = data => {
  const url = '/newCartContract/deleteCartGoods';
  return sendPost({ url, data });
};

// 根据spu 查询sku
export const fetchSkuBySpuId = data => {
  const url = '/trade/goods/findGoodsSkus';
  return sendPost({ url, data });
};

export const queryFreight = data => {
  const url = '/newCartContract/queryFreight';
  return sendPost({ url, data });
};

export const fetchCartCount = data => {
  const url = '/newCartContract/userCartItemCount';
  return sendPost({ url, data: {...data, ignore: true} });
};

// 获取商品促销信息
export const getActivityTag = data => {
  const url = '/trade/promotion/tags';
  return sendPost({ url, data });
};